import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ILogEventFormMeta {
    terminalNumber: FormInputMeta;
    status: FormInputMeta;
    atmEventCode: FormInputMeta;
    eventType: FormInputMeta;
    fromDate: FormInputMeta;
    toDate: FormInputMeta;

    schema: any;
}

const logEventFormMeta = {} as ILogEventFormMeta;

logEventFormMeta.terminalNumber = {
    name: "terminalNumber",
    type: "select",
    label: "Numéro Terminal",
    placeholder: "",
    validation: yup.string()
};

logEventFormMeta.status = {
    name: "status",
    type: "text",
    label: "Statut",
    placeholder: "",
    validation: yup.string()
};

logEventFormMeta.atmEventCode = {
    name: "atmEventCode",
    type: "select",
    label: "Atm Event Code",
    placeholder: "",
    validation: yup.string()
};

logEventFormMeta.eventType = {
    name: "eventType",
    type: "select",
    label: "Type Evènement",
    placeholder: "",
    validation: yup.string()
};

logEventFormMeta.fromDate = {
    name: "fromDate",
    type: "date",
    label: "De",
    placeholder: "",
    validation: yup.date().optional()
};

logEventFormMeta.toDate = {
    name: "toDate",
    type: "date",
    label: "A",
    placeholder: "",
    validation: yup.date().optional()
};

logEventFormMeta.schema = yup.object().shape(getValidationSchema(logEventFormMeta));

export default logEventFormMeta;